export default "__VITE_ASSET__B2iH2VJM__"